/**
 * @module lib/arr Array utilities
 */

export const first = arr => arr[0];

export const last = arr => (typeof arr.length === 'number' ? arr[arr.length - 1] : undefined);
